export default __webpack_public_path__ + "static/media/icon_pause.10bbeec1.svg";